// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-crud-component {
  font-family: Arial, sans-serif;
  max-width: 1900px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.common-crud-component h1 {
  font-size: 24px;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.common-crud-component-form {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.common-crud-component-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}

.common-crud-component-form input[type="text"],
.common-crud-component-form select,
.common-crud-component-form textarea {
  width: calc(100% - 20px);
  padding: 8px 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.common-crud-component-form button {
  background-color: #007bff;
  color: white;
  padding: 8px 12px;
  margin-right: 5px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.common-crud-component-form button:hover {
  background-color: #0056b3;
}

.common-crud-component table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.common-crud-component th,
.common-crud-component td {
  text-align: left;
  padding: 10px;
  border: 1px solid #ddd;
}
.common-crud-component td {
    font-weight: 100;
}

.common-crud-component th {
  background-color: #f2f2f2;
  font-weight: bold;
  cursor: pointer;
}

.common-crud-component tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

.common-crud-component tbody tr:nth-child(even) {
  background-color: #ffffff;
}

.common-crud-component button {
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.common-crud-component button:hover {
  background-color: #0056b3;
}

.common-crud-component .search-input {
  padding: 8px 12px;
  width: 200px;
  margin-left: auto;
  display: block;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.common-crud-component .search-input:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CrudComponent.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;IACI,gBAAgB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C","sourcesContent":[".common-crud-component {\n  font-family: Arial, sans-serif;\n  max-width: 1900px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.common-crud-component h1 {\n  font-size: 24px;\n  color: #333;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.common-crud-component-form {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.common-crud-component-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #555;\n}\n\n.common-crud-component-form input[type=\"text\"],\n.common-crud-component-form select,\n.common-crud-component-form textarea {\n  width: calc(100% - 20px);\n  padding: 8px 10px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.common-crud-component-form button {\n  background-color: #007bff;\n  color: white;\n  padding: 8px 12px;\n  margin-right: 5px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.common-crud-component-form button:hover {\n  background-color: #0056b3;\n}\n\n.common-crud-component table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.common-crud-component th,\n.common-crud-component td {\n  text-align: left;\n  padding: 10px;\n  border: 1px solid #ddd;\n}\n.common-crud-component td {\n    font-weight: 100;\n}\n\n.common-crud-component th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.common-crud-component tbody tr:nth-child(odd) {\n  background-color: #f9f9f9;\n}\n\n.common-crud-component tbody tr:nth-child(even) {\n  background-color: #ffffff;\n}\n\n.common-crud-component button {\n  background-color: #007bff;\n  color: white;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 3px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.common-crud-component button:hover {\n  background-color: #0056b3;\n}\n\n.common-crud-component .search-input {\n  padding: 8px 12px;\n  width: 200px;\n  margin-left: auto;\n  display: block;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.common-crud-component .search-input:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
